import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Form, Button } from "react-bootstrap";
import PlainTextField from "../../common/forms/PlainTextField";
import RevShareModal from "../../common/overrides/RevShareModal";
import { getRoundedRateAgnosticDollars } from "../../../apis/revshare/HourUtilizationApi";
import { saveRateAgnosticHourUtilizationRequest } from "../../../redux/actions/HourUtilizationRequestActions";
import FormRow from "../../common/forms/FormRow";
import DollarValueInput from "../../common/forms/DollarValueInput";
import Information from "../../common/alerts/Information";

class RateAgnosticHourUtilizationRequestModal extends React.Component {
  render() {
    return (
      <RevShareModal
        buttonSize="md"
        buttonText="Request Cash Out"
        buttonVariant="primary"
        title="RevShare Utilization Request"
        yesButtonOnClick={this.submitUtilizationRequest}
        yesButtonClicked={this.state.saving}
        onSuccess={this.props.onSuccess}
      >
        <Form noValidate ref={(element) => (this.form = element)} validated={this.state.validated}>
          <FormRow
            columns={[
              <PlainTextField inline label="Available Cash" value={`$${this.props.requestableDollars.toFixed(2)}`} />,
            ]}
          />
          <FormRow
            autoSizedColumns={[false, true]}
            columns={[
              <DollarValueInput
                label="Total Requested"
                onChange={this.onDollarsChange}
                value={0.0}
                ref={(element) => (this.totalValueField = element)}
              />,
              <Form.Group>
                <Button
                  onClick={() => {
                    this.setState({
                      request: {
                        ...this.state.request,
                        dollarsRequested: this.props.requestableDollars,
                      },
                    });
                    this.totalValueField.value = this.props.requestableDollars.toFixed(2);
                  }}
                  variant="primary"
                >
                  All
                </Button>
              </Form.Group>,
            ]}
          />
          <Information>
            <span>
              Cash out requests made using this form will be subtracted from the rates that have been in your bank for
              the longest first.
            </span>
          </Information>
          <Information>
            <div className="align-items-center d-flex">
              <span>
                Requested cash out must factor out to 15 minute increments. Click "Round" to see the totals that will be
                submitted.
              </span>
              <span className="ml-auto">
                <Button
                  onClick={() =>
                    getRoundedRateAgnosticDollars(
                      this.totalValueField.value,
                      this.props.consultantId || this.props.profile.ghost || null
                    ).then((response) => {
                      this.totalValueField.value = response.actualDollars.toFixed(2);
                    })
                  }
                  variant="info"
                >
                  Round
                </Button>
              </span>
            </div>
          </Information>
        </Form>
      </RevShareModal>
    );
  }

  constructor(props) {
    super(props);
    this.state = {
      saving: false,
      request: {
        dollarsRequested: 0.0,
        utilizattionType: 0,
      },
      typing: null,
    };

    this.onDollarsChange = this.onDollarsChange.bind(this);
    this.formIsValid = this.formIsValid.bind(this);
    this.submitUtilizationRequest = this.submitUtilizationRequest.bind(this);
  }

  handleClose = () => this.setState({ show: false });

  handleShow() {
    this.setState({
      show: true,
      saving: false,
      request: {
        dollarsRequested: 0.0,
        utilizattionType: 0,
      },
    });
  }

  onDollarsChange() {
    let newRequest = {
      ...this.state.request,
      dollarsRequested: parseFloat(this.totalValueField.value),
    };
    this.setState({ request: newRequest });
  }

  formIsValid() {
    const errors = {
      hoursExceedMinError: "you must request more than 0 hours to be utilized.",
      hoursExceedMaxError: "You cannot request more hours than you have availible.",
    };
    let isValid = true;
    let alert = "The following error(s) exist in the form:";

    if (this.state.request.actualDollars <= 0.0) {
      alert = alert + "\n\t" + errors.hoursExceedMinError;
      isValid = false;
    }
    if (this.state.request.actualDollars > this.props.requestableDollars) {
      alert = alert + "\n\t" + errors.hoursExceedMaxError;
      isValid = false;
    }

    if (!isValid) {
      window.alert(alert);
    }

    return isValid;
  }

  submitUtilizationRequest(event) {
    if (!this.formIsValid()) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      this.setState({ saving: true });
      return this.props.saveRequest(this.state.request, this.props.consultantId || this.props.profile.ghost || null);
    }
  }
}

RateAgnosticHourUtilizationRequestModal.propTypes = {
  requestableDollars: PropTypes.number.isRequired,
  consultantId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onSuccess: PropTypes.func,
};

function mapStateToProps(state, ownProps) {
  return {
    availableHours: state.availableHours,
    profile: state.profile,
  };
}

const mapDispatchToProps = {
  saveRequest: saveRateAgnosticHourUtilizationRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(RateAgnosticHourUtilizationRequestModal);
